import FormSelectBox from '@views/components/Inputs/FormSelectBox';

import { useGetShipTerms } from '@/modules/entities';

export const ShipTermSelect = ({
  name = 'quoteTerms',
  label,
  editMode = true,
  placeholder = 'Select Shipment Term',
  rules = [],
  isRequired,
  dataTestId,
  ...rest
}) => {
  const { data, isLoading } = useGetShipTerms();

  const options = data?.list ?? [];

  return (
    <FormSelectBox
      name={name}
      label={label}
      editMode={editMode}
      placeholder={placeholder}
      rules={rules}
      isRequired={isRequired}
      dataTestId={dataTestId}
      options={options}
      loading={isLoading}
      {...rest}
    />
  );
};
